import Vue from "vue";
import App from "./App.vue";
import VueRouter from "vue-router";
import store from "./store";
import routes from "./routes";
import VueAxios from "vue-axios";
import axios from "axios";
import { VueAuthenticate } from "vue-authenticate";
import Kuvera from "./services/kuvera.js";

require("./config/development.js");

Vue.use(VueRouter);
Vue.use(VueAxios, axios);
Vue.use(Kuvera);


Vue.vueAuth = new VueAuthenticate(Vue.prototype.$http, {
  baseUrl: Vue.config.EL_DORADO_API_URL + "/api/v3/users/", // Your API domain
  loginUrl: "/authenticate.json",
  registerUrl: "/register.json",
  tokenPath: "token",

  providers: {
    google: {
      clientId: Vue.config.GOOGLE_CLIENTID,
      redirectUri: window.location.origin + "/auth/callback" // Your client app URL
    }
  }
});

// Vue.use(VueAuthenticate, {
//   baseUrl: Vue.config.EL_DORADO_API_URL + "/api/v3/users/", // Your API domain
//   tokenPath: "token",
//   loginUrl: "/authenticate.json",
//   registerUrl: "/register.json",

//   providers: {
//     google: {
//       clientId: Vue.config.GOOGLE_CLIENTID,
//       //display: "popup",
//       // popupOptions: {}
//       redirectUri: window.location.origin + "/auth/callback" // Your client app URL
//     }
//   }
// });

const router = new VueRouter({
  routes, // short for `routes: routes`,
  mode: "history"
});
Vue.config.productionTip = false;
Vue.directive("title", {
  inserted: (el, binding) => (document.title = binding.value),
  update: (el, binding) => (document.title = binding.value)
});
const app = new Vue({ el: "#app", router, store, render: h => h(App) });


router.beforeEach((to, from, next) => {
  let isAuthenticated = Vue.vueAuth.isAuthenticated();

  if (to.matched.some(record => record.meta.auth) && !isAuthenticated) {
    // if route requires auth and user isn't authenticated
    app.$store
      .dispatch("adminLogout", app)
      .then(() => {
        next("/");
      })
      .catch(() => {
        next();
      });
  } else {
    next();
  }
});
